import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { SubmissionError } from "redux-form";
import { trackProps, withTrack } from "@dpdgroupuk/react-event-tracker";
import { withOverlay, withSnackbar } from "@dpdgroupuk/mydpd-ui";
import SetNewPasswordForm from "./SetNewPasswordForm";
import PasswordChangeHelperText from "../../../../components/PasswordChangeHelperText";
import { SET_NEW_PASSWORD_PAGE } from "../../../../constants/analytics";
import { NavigationUtil } from "../../../../utils";
import PasswordChangeSuccess from "../PasswordChangeSuccess";
import { ROUTE } from "../../../../constants";
import { withAppContext } from "../../../../Context";
import styles from "./SetNewPassword.module.scss";
import * as AuthErrors from "../../../../features/Auth/AuthErrors";

const SetNewPassword = ({
  validateInviteLink,
  onSetNewPassword
}) => {
  const [isLoading, setLoading] = useState(true);
  const [passwordUpdated, setPasswordUpdated] = useState(false);
  const oobCode = NavigationUtil.getUrlSearchParam("oobCode");
  useMemo(async () => {
    await validateInviteLink(window.location.href);
    setLoading(false); // eslint-disable-next-line
  }, []);

  const onSubmitSetNewPassword = async (oobCode, formValues) => {
    await onSetNewPassword(oobCode, formValues);
    setPasswordUpdated(true);
  };

  if (passwordUpdated) {
    return /*#__PURE__*/React.createElement(PasswordChangeSuccess, null);
  }

  if (isLoading) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: styles.title
  }, "Change your DPD password"), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    md: 6,
    lg: 5
  }, /*#__PURE__*/React.createElement(SetNewPasswordForm, {
    enabled: !isLoading,
    oobCode: oobCode,
    onSubmit: onSubmitSetNewPassword
  })), /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    md: 6,
    lg: 5
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.divider
  }, /*#__PURE__*/React.createElement(PasswordChangeHelperText, {
    text: `You’ve come to the right place to change your password.<br /><br />You are seeing this page because a request was made to reset your account password.<br /><br />If you did not make this request, please close this page and contact your account admin.`
  })))));
};

SetNewPassword.propTypes = {
  validateInviteLink: PropTypes.func,
  onSetNewPassword: PropTypes.func
};
export default compose(withOverlay, withSnackbar, withAppContext, connect(null, (dispatch, {
  overlay,
  history,
  app,
  snackbar
}) => ({
  validateInviteLink: overlay.showWhile(async link => {
    try {
      // user will come to that from email link
      const {
        valid
      } = await app.auth.validateInvite(link);

      if (!valid) {
        // noinspection ExceptionCaughtLocallyJS
        throw new Error("Invalid link");
      }
    } catch (e) {
      snackbar.showAlert({
        message: "Expired link, reset password again",
        displayTime: 10000
      });
      history.push({
        pathname: ROUTE.LOGON_PAGE,
        state: {
          _error: "Reset token is expired"
        }
      });
    }
  }),
  onSetNewPassword: overlay.showWhile(async (oobCode, {
    newPassword,
    newPasswordConfirmation
  }) => {
    try {
      await app.auth.updatePassword(oobCode, newPassword, newPasswordConfirmation);
    } catch (e) {
      throw new SubmissionError({
        _error: AuthErrors.getUserAuthFormError(e)
      });
    }
  })
})), withTrack(trackProps(SET_NEW_PASSWORD_PAGE)))(SetNewPassword);